/*
 * @Author: 刘小博
 * @Date: 2023-02-07 14:35:53
 * @LastEditTime: 2023-05-10 19:41:12
 * @LastEditors: 肖玲
 * @Description:
 * @FilePath: \p2ps_vip_web\src\router\behavior-manage\behavior-statistics-report\modules\prescriptionAnalyseRouter.js
 * 处方分析
 */
const prescriptionAnalyseRouter = [
  // meta_type 1-处方拜访KPI统计 2-经理辅导分析 3-otc拜访KPI统计 4-拜访线路效率报告
  {
    path: '/behaviorManage/doctor-kpi/:meta_type',
    name: 'doctorDataKpi',
    component: () =>
      import(
        /*webpackChunkName:"behaviorManage-doctor-kpi-meta_type" */
        '@/views/behavior-manage/behavior-statistics-report/prescription-analyse/Page.vue'
      ),
    meta: {
      SecondaryMenu: '处方分析', //二级菜单
      isMoreMeta: true,
      1: {
        title: '拜访KPI统计'
      },
      2: {
        title: '经理辅导分析'
      },
      3: {
        title: '拜访KPI统计'
      },
      4: {
        title: '拜访线路效率报告'
      }
    }
  },
  // 医生分级变化统计
  {
    path: '/behaviorManage/statistics-change-doctor-grading',
    name: 'behaviorManage-statistics-change-doctor-grading',
    component: () =>
      import(
        /*webpackChunkName:"behaviorManage-statistics-change-doctor-grading" */
        '@/views/behavior-manage/behavior-statistics-report/prescription-analyse/statistics-change-doctor-grading/Page.vue'
      ),
    meta: {
      SecondaryMenu: '处方分析', //二级菜单
      title: '医生分级变化统计'
      // breadcrumb: [
      //   {
      //     title: '处方分析',
      //   },
      // ],
    }
  }
]
export default prescriptionAnalyseRouter
